module.exports = {"id":"178773","name":"Nikolay Dimitrov","rating":"72","photo":"./data/images/photos/0/178773.png","club":{"name":"FK Oural","logo":"./data/images/clubs/FKOural.png"},"positions":["MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NikolayDimitrov0.json
// module id = 3228
// module chunks = 0